import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ImportRubricasResult, RubricaCadastroResult } from './dp-rubricas.models';

@Injectable({ providedIn: 'root' })
export class DpRubricasService {
  private readonly base = `${environment.apiUrl}/v1/dp/rubricas-empresa`;

  constructor(private readonly http: HttpClient) {}

  cadastrar(
    codiEmp: number,
    rubricaEsocial: string,
    rubricaDominio: number,
    descricao?: string
  ): Observable<RubricaCadastroResult> {
    let params = new HttpParams()
      .set('codi_emp', codiEmp)
      .set('rubrica_esocial', rubricaEsocial)
      .set('rubrica_dominio', rubricaDominio);

    const texto = descricao?.trim();
    if (texto) {
      params = params.set('descricao', texto);
    }

    return this.http.post<RubricaCadastroResult>(this.base, null, { params });
  }

  importarPlanilha(arquivo: File): Observable<ImportRubricasResult> {
    const form = new FormData();
    form.append('planilha', arquivo, arquivo.name);
    return this.http.post<ImportRubricasResult>(`${this.base}/importar-planilha`, form);
  }

  gerarPlanilhaEsocial(codiEmp: number, arquivos: File[]): Observable<HttpResponse<Blob>> {
    const form = new FormData();
    for (const arquivo of arquivos) {
      form.append('xmls', arquivo, arquivo.name);
    }

    return this.http.post(`${this.base}/planilha-esocial`, form, {
      params: { codi_emp: codiEmp },
      responseType: 'blob',
      observe: 'response'
    });
  }
}
